var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFeedback64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speech-bubble",
    transform: "translate(9.000000, 16.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,10 L45,27.28 C45,28.3845695 44.1045695,29.28 43,29.28 L39.1818182,29.28 L39.1818182,29.28 L39.1333333,36 L33.3636364,29.28 L15,29.28 C13.8954305,29.28 13,28.3845695 13,27.28 L13,10 C13,8.8954305 13.8954305,8 15,8 L43,8 C44.1045695,8 45,8.8954305 45,10 Z",
    id: "Speech-bubble-recieve",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.00694484 C0,0.89853981 0.889261723,0 2.00174332,0 L29.9982567,0 C31.103789,0 32,0.898059286 32,2.00694484 L32,19.5315167 C32,20.6399217 31.0987247,21.5384615 29.9917258,21.5384615 L11.6363636,21.5384615 L5.86666667,28 L5.86666667,21.5384615 L2.00256536,21.5384615 C0.896579051,21.5384615 0,20.6404023 0,19.5315167 L0,2.00694484 Z",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFeedback64);
export default __webpack_public_path__ + "static/media/pictogramBeaconFeedback64.a6faf2f95b022e1333c1d8e4875bb3a0.svg";
export { ForwardRef as ReactComponent };